module.exports = __webpack_public_path__ + "static/submitted-bg.372455bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/submitted-bg.svg
// module id = 872
// module chunks = 168707334958949